import { useRef, useState } from 'react';

import { useEventCallback } from '../../common/utils/hooks';

// Claim synchronously: a second tap can arrive before React renders the spinner.
const usePickListItemAction = () => {
	const pendingIdsRef = useRef(new Set());
	const [pendingItemIds, setPendingItemIds] = useState([]);
	const [pickError, setPickError] = useState(null);

	const runPickAction = useEventCallback(async (ids, action) => {
		const itemIds = Array.isArray(ids) ? ids : [ids];
		if (!itemIds.length || itemIds.some(id => pendingIdsRef.current.has(id))) {
			return null;
		}

		itemIds.forEach(id => pendingIdsRef.current.add(id));
		setPendingItemIds([...pendingIdsRef.current]);
		setPickError(null);
		try {
			return await action();
		}
		catch (error) {
			setPickError(error?.networkError
				? 'Unable to save picked status. Check your connection and try again.'
				: error?.message || 'Unable to save picked status. Try again.');
			return null;
		}
		finally {
			itemIds.forEach(id => pendingIdsRef.current.delete(id));
			setPendingItemIds([...pendingIdsRef.current]);
		}
	});

	return { pendingItemIds, pickError, runPickAction };
};

export default usePickListItemAction;
